<template>
  <div>
    <v-overlay :z-index="5000" :value="loading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-card class="ma-4" id="head_height">
      <v-toolbar dense flat color="white">
        <v-toolbar-title class="font-weight-bold">
          <v-icon class="mr-2">mdi-police-badge</v-icon>보안규정 위반내역
        </v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>        
        <v-btn @click="Initialize();" icon small>
          <v-icon>
            refresh
          </v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          color="blue"
          text
          @click="openPdf()"
          class="ml-2 font-weight-bold text-subtitle-1"
        >
          <v-icon class="mr-2">mdi-file-download-outline</v-icon>사유서 양식 다운로드
        </v-btn>
      </v-toolbar>
      <v-divider class="ml-2 mr-2"></v-divider>
      <v-card-text>
        <IronDate v-model="sNowSelectDate" @update="onDateRangeChange" cLabel="발생일시" ref="IronDateRef" style="width:230px;" class="hidden-sm-and-down"/>
        <IronDate v-model="sNowSelectDate" @update="onDateRangeChange" cLabel="발생일시" ref="IronDateRef" style="width:100%;" class="hidden-md-and-up"/>
      </v-card-text>
    </v-card>


    <v-card class="ma-4" v-resize="onResize">
      <v-data-table
        :headers="headers"
        :items="Records"
        :items-per-page="15"
        :height="ChangableHeight"
        :single-select="bSingleSelect"
        fixed-header
        @click:row="handleClick"
        @dblclick:row="handleDoubleClick(selected[0])"
        item-key="cPenaltyId"
      >
        <template v-slot:item.cCorpNm="{ item }">
          <div v-show="item.cLocal == 'Y'">{{item.cCorpNmKor}}</div>
          <div v-show="item.cLocal == 'N'">{{item.cCorpNmEng}}</div>
        </template>
        <template v-slot:item.cPointOutDate="{ item }">
          <div>{{item.cPointOutDate.substring(0,16)}}</div>
        </template>
        <template v-slot:item.cViolate="{ item }">
          <div class="hidden-sm-and-down" align="center">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <div class="text-truncate" style="max-width:420px;" v-bind="attrs" v-on="on">{{getViolate(item.cViolate)}}</div>
              </template>
              <div style="max-width:1000px !important;">{{getViolate(item.cViolate)}}</div>
            </v-tooltip>
          </div>
          <div class="hidden-md-and-up" align="center">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <div class="text-truncate" style="max-width:160px;" v-bind="attrs" v-on="on">{{getViolate(item.cViolate)}}</div>
              </template>
              <div style="max-width:400px !important;">{{getViolate(item.cViolate)}}</div>
            </v-tooltip>
          </div>
        </template>
        <template v-slot:item.cPenaltyState="{ item }">
          <v-chip label small :color="getPenaltyColor(item.cState)" class="white--text">{{getPenalty(item.cState)}}</v-chip>
        </template>
        <template v-slot:item.cPenaltyResult="{ item }">
          {{getPenaltyType(item.cPenaltyType)}}
        </template>
        <template v-slot:item.cProcessInfo="{ item }">
          <v-chip v-if="!(item.cRefuse == 'Y' && item.cProcessInfo == 'X')" label small :color="getProcessColor(item.cProcessInfo)" class="white--text">{{getProcess(item.cProcessInfo)}}</v-chip>
          <v-chip v-else label small color="grey" class="white--text">영구 출입 정지 취소</v-chip>
          <!-- <v-chip label small :color="getProcessColor(item.cProcessInfo)" class="white--text">{{getProcess(item.cProcessInfo)}}</v-chip> -->
        </template>
        <template v-slot:item.cFileInput="{ item }">
          <v-btn v-show="(item.cPenaltyType == 'WC' || item.cPenaltyType == 'CO') && (item.cState == 'R' && item.cCorpId == CustomInfo.CorpId && (CustomInfo.Manager == 'M' || CustomInfo.Manager == 'S')) || (item.cState == 'A' && item.cCorpId == CustomInfo.CorpId && item.cSubMissionCustomId == CustomInfo.CustomId)" @click="ShowFileDialog(item)" small><v-icon small>mdi-file-document-multiple-outline</v-icon></v-btn>
          <!-- <v-btn v-show="item.cState == 'R' && item.cCorpId == CustomInfo.CorpId && (CustomInfo.Manager == 'M' || CustomInfo.Manager == 'S')" @click="ShowFileDialog(item)" small><v-icon small>mdi-file-document-multiple-outline</v-icon></v-btn>
          <v-btn v-show="item.cState == 'A' && item.cCorpId == CustomInfo.CorpId && item.cSubMissionCustomId == CustomInfo.CustomId" @click="ShowFileDialog(item)" small><v-icon small>mdi-file-document-multiple-outline</v-icon></v-btn> -->
        </template>
        <template v-slot:item.cSubMissionDate="{ item }">
          <!-- <div>{{item.cSubMissionDate.substring(0,10)}}</div> -->
          <!-- <div v-if="!(item.cSuspenPeriod == '0' || item.cProcessInfo == 'X') && item.cRefuse == 'N'">{{getSubMissionDate(item.cSubMissionDate)}}</div> -->
          <div v-if="item.cState != 'R' && !(item.cSuspenPeriod == '0' || item.cProcessInfo == 'X') && item.cRefuse == 'N'">{{item.cSubMissionDate.substring(0,10)}}</div>
        </template>
        <template v-slot:item.cUserNm="{ item }">
          <!-- <div>{{item.cSubMissionDate.substring(0,10)}}</div> -->
          <!-- <div v-if="!(item.cSuspenPeriod == '0' || item.cProcessInfo == 'X') && item.cRefuse == 'N'">{{getSubMissionDate(item.cSubMissionDate)}}</div> -->
          <div v-if="item.cUserId != 'NONE'">{{item.cUserNm}}</div>
        </template>
        <template v-slot:item.cRequestDate="{ item }">
          <div v-if="item.cState != 'R'">{{item.cRequestDate.substring(0,10)}}</div>
        </template>
        <template v-slot:item.cOKDateTime="{ item }">
          {{item.cOKDateTime.substring(0,10)}}
        </template>
        <!-- <template v-slot:item.cElapsedDays="{ item }">
          <div>{{getElapsedDays(item.cPointOutDate)}}</div>
        </template> -->
        <template v-slot:no-data>
          <div class="black--text">{{cNoMsg}}</div>
        </template>
      </v-data-table>
    </v-card>

    <v-dialog v-model="cFileDialog" v-if="cFileDialog" max-width="600px" persistent>
      <v-card flat tile>
        <v-toolbar dense flat color="white">
          <v-toolbar-title class="font-weight-bold">
            <v-icon class="mr-2">mdi-image-plus</v-icon>파일 첨부
          </v-toolbar-title>
        </v-toolbar>
        <v-divider class="ml-4 mr-4"></v-divider>
        <v-card-text class="pr-4 pl-4 pb-6 pt-6 mt-2">
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field v-model="editedItem.cCustomNm" label="이름" disabled dense hide-details persistent-placeholder></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field v-if="editedItem.cLocal == 'Y'" v-model="editedItem.cCorpNmKor" label="업체명" disabled dense hide-details persistent-placeholder></v-text-field>
              <v-text-field v-else v-model="editedItem.cCorpNmEng" label="업체명" disabled dense hide-details persistent-placeholder></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field v-model="editedItem.cTel" label="전화번호" disabled dense hide-details persistent-placeholder></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field v-model="editedItem.cNational" label="국적" disabled dense hide-details persistent-placeholder></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field v-model="editedItem.cPointOutDate" label="발생일시" disabled dense hide-details persistent-placeholder></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field v-model="editedItem.cPointOutZone" label="발생장소" disabled dense hide-details persistent-placeholder></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field v-model="editedItem.cViolate" label="위반내용" disabled dense hide-details persistent-placeholder></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field v-model="editedItem.cProcessInfo" label="처분내용" disabled dense hide-details persistent-placeholder></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-textarea v-if="editedItem.cState == 'A'" v-model="editedItem.cComment" label="재검토 사유" outlined readonly no-resize persistent-placeholder dense></v-textarea>
            </v-col>
            <v-col cols="12" align="center">
              <v-card outlined class="pa-4">
                <v-img
                  :src="sNowPath"
                  contain
                  max-height="350px"
                  max-width="350px"
                ></v-img>
              </v-card>
              <v-card flat class="pt-4">
                <v-file-input
                  v-on:change="onSelFile(NowSelFile)"
                  v-model="NowSelFile"
                  class="mt-2"
                  accept="image/png"
                  :placeholder="editedItem.cFileNm"
                  dense
                ></v-file-input>
              </v-card>
            </v-col>
            <v-col cols="12" sm="12" md="12" align="right" class="pt-0 pb-0">
              <v-divider class="mb-2"></v-divider>
              <v-btn @click="CloseDialog()" text class="mr-2"><v-icon class="mr-2">mdi-close</v-icon>취소</v-btn>
              <v-btn @click="SetPenaltyInfo()" dark class="ml-2"><v-icon class="mr-2">save</v-icon>첨부</v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import BasicInfo from "../BasicInfo.js";
import axios from "axios"
import EventBus from '@/eventBus.js';

import IronDate from '@/components/iron28Calendar/src/IronDate3.vue';
import Util from "../Util.js";

export default {
  components: {
    IronDate,
  },
  data: () => ({
    cNoMsg : "",
    ChangableHeight : "",
    NowSelFile : null,
    bSingleSelect : true,
    loading : false,
    cFileDialog : false,
    sNowPath : "",
    date2 : new Date(Util.sFormatDate(Date())),
    sNowSelectDate :  Util.sFormatDate(Util.sYearFirstDate()) + " ~ " +  Util.sFormatDate(Date()),
    sStartDate : Util.sFormatDate(Util.sYearFirstDate()),
    sEndDate : Util.sFormatDate(Date()),
    selected : [],
    headers: [
      { text: 'No', value: 'sNum', width:"10"},
      { text: '이름', value: 'cCustomNm',width:"80"},
      { text: '소속', value: 'cCorpNm',width:"100"},
      { text: '전화번호', value: 'cTel',width:"100"},
      { text: '발생일시', value: 'cPointOutDate',width:"160"},
      // { text: '발생장소', value: 'cPointOutZone'},
      { text: '위반내용', value: 'cViolate', align : "center"},
      { text: '처분내용', value: 'cProcessInfo', align : "center",width:"80"},
      { text: '상태', value: 'cPenaltyState', align : "center",width:"80"},
      // { text: '처분결과', value: 'cActionResult', align : "center",width:"200"},
      { text: '처분결과', value: 'cPenaltyResult', align : "center",width:"200"},
      { text: '사유서/공문 제출', value: 'cFileInput', align : "center",width:"80"},
      { text: '제출일시', value: 'cSubMissionDate',width:"120", align : "center"},
      { text: '재검토 요청일시', value: 'cRequestDate', align : "center",width:"80"},
      // { text: '경과일', value: 'cElapsedDays', align : "center",width:"80"},
      { text: '출입 정지 기간', value: 'cSuspenPeriod', align : "center",width:"120"},
      { text: '결재자', value: 'cUserNm', align : "center",width:"120"},
      { text: '결재일시', value: 'cOKDateTime', align : "center",width:"120"},
    ],
    Records : [],
    iEditIndex : -1,
    editedItem : {
      cComment : "",
      cFileId : "",
      cPenaltyId : "",
      cCustomNm : "",
      cTel : "",
      cNational : "",
      cLocal : "",
      cCorpNmKor : "",
      cCorpNmEng : "",
      cPointOutDate : "",
      cPointOutZone : "",
      cProcessInfo : "",
      cFileNm : "",
      cSubMissionCustomId : "",
      cThumbnailpath : "",
    },
  }),
  computed: {
    ...mapState(["CustomInfo","zViolate","zPenaltyState","FMaxSize3","zFileType","zProcessState"]),
  },
  created() {
  },

  mounted() {
    this.Initialize();
  },

  methods : {
    onResize(){
      let h1 = document.getElementById('footer_height').clientHeight
      let h2 = document.getElementById('head_height').clientHeight

      let iCalcHeight = window.innerHeight - h1 - h2 - 136

      if (iCalcHeight >= 300) {
        this.ChangableHeight = String(iCalcHeight) + "px"
      } else {
        this.ChangableHeight = "300px"
      }
    },

    Initialize(){
      this.DataInit();
      this.GetPenaltyInfo();
    },

    DataInit(){
      this.sStartDate = Util.sFormatDate(Util.sYearFirstDate());
      this.sEndDate = Util.sFormatDate(Date());
      this.sNowSelectDate = this.sStartDate + " ~ " + this.sEndDate;
      this.cNowSearchKeyWord = "";
    },

    onDateRangeChange(daterange){            
      this.sStartDate = Util.sFormatDate(daterange.startDate);
      this.sEndDate = Util.sFormatDate(daterange.endDate);
      this.sNowSelectDate = this.sStartDate + " ~ " +  this.sEndDate;
      this.GetPenaltyInfo();
    },

    openPdf() {
      window.open('/PenaltyDocument.docx', '_blank').focus();
    },

    getViolate(cViolate) {
      return this.zViolate.find((e) => {return e.value == cViolate})?.text
    },
    
    getPenaltyColor(cState) {
      return this.zPenaltyState.find((e) => {return e.value == cState})?.color
    },
    
    getPenalty(cState) {
      return this.zPenaltyState.find((e) => {return e.value == cState})?.text
    },

    getProcessColor(cProcessInfo) {
      return this.zProcessState.find((e) => {return e.value == cProcessInfo})?.color
    },
    
    getProcess(cProcessInfo) {
      return this.zProcessState.find((e) => {return e.value == cProcessInfo})?.text
    },

    getPenaltyType(cPenaltyType){
      // if (cPenaltyType == 'W') return '경고'
      // else if (cPenaltyType == 'C') return '사유서'
      // else if (cPenaltyType == 'O') return '공문'
      if (cPenaltyType == 'WC') return '경고 누적, 사유서 제출, 30일 출입정지'
      else if (cPenaltyType == 'CO') return '사유서 누적, 공문 제출, 180일 출입정지'
      else return ''
    },
    // getElapsedDays(cPointOutDate) {
    //   const date1 = new Date(cPointOutDate.substring(0,10));

    //   const elapsedMSec = this.date2.getTime() - date1.getTime(); // 172800000
    //   const elapsedDay = elapsedMSec / 1000 / 60 / 60 / 24;

    //   if (elapsedDay >= 0) {
    //     return elapsedDay + "일"
    //   } else {
    //     return -elapsedDay + "일전"
    //   }
    // },

    handleClick(value) {
      this.selected = [value];
    },

    handleDoubleClick(item) {
      // ((CustomInfo.Manager == 'S' || CustomInfo.Manager == 'M') && CustomInfo.CorpId == item.cCorpId )||((CustomInfo.Manager == 'N') && CustomInfo.CustomId == item.cCustomId && CustomInfo.CorpId == item.cCorpId)
      if (!((item.cPenaltyType == 'WC' || item.cPenaltyType == 'CO') && (item.cState == 'R' && item.cCorpId == this.CustomInfo.CorpId && (this.CustomInfo.Manager == 'M' || this.CustomInfo.Manager == 'S')) || (item.cState == 'A' && item.cCorpId == this.CustomInfo.CorpId && item.cSubMissionCustomId == this.CustomInfo.CustomId))) return
      // if (item.cCustomId != this.CustomInfo.CustomId && this.CustomInfo.Manager == "N") return
      // if (item.cCustomId != this.CustomInfo.CustomId && this.CustomInfo.Manager != "N" && item.cState == BasicInfo.REQ_TYPE_VISIT_STATE_REQ) return

      if (this.selected.length > 0 || item.cPenaltyId != undefined) {
        this.ShowFileDialog(this.selected[0])
      }
    },

    // 파일 선택시 정보 불러오기
    onSelFile(NowSelFile) {
      let bFileType = false

      if (NowSelFile != null)  {
        if (NowSelFile.size > this.FMaxSize3)  {
          this.sNowPath = BasicInfo.FILE_API + this.editedItem.cThumbnailpath
          setTimeout(() => {
            this.NowSelFile = null;
          }, 300);
          EventBus.$emit("onShowMsgBox","첨부하신 파일의 용량의 크기를 확인하여 주세요.","첨부하실수 있는 파일의 크기는 최대 10MB까지 입니다.");
          return
        }

        for ( let i in this.zFileType) {
          if (this.zFileType[i] == NowSelFile.type) {
            bFileType =  true;
            break
          }
        }
      } else {
        bFileType = true
        this.sNowPath = BasicInfo.FILE_API + this.editedItem.cThumbnailpath
      }

      if (!bFileType) {
        setTimeout(() => {
          this.NowSelFile = null;
        }, 300);
        EventBus.$emit("onShowMsgBox","첨부하신 파일의 형식을 확인하여 주세요.","첨부하실수 있는 파일의 형식은 JPG,JPEG,PNG,GIF 입니다.");
        return
      }

      const reader = new FileReader

      reader.onload = e => {
        var imageData = e.target.result;
        this.sNowPath = imageData;
      }
      try {
        reader.readAsDataURL(NowSelFile)
      } catch (error) {
        this.sNowPath = BasicInfo.FILE_API + this.editedItem.cThumbnailpath
        EventBus.$emit("onFileBus", true,""+error);
      }
    },

    ShowFileDialog(item) {
      this.iEditIndex = this.Records.indexOf(item)
      this.editedItem = JSON.parse(JSON.stringify(item));
      this.editedItem.cPointOutDate = item.cPointOutDate.substring(0,10);
      this.editedItem.cViolate = this.getViolate(item.cViolate);
      this.editedItem.cFileId = item.cFileId;
      this.editedItem.cProcessInfo = this.getProcess(item.cProcessInfo);
      this.sNowPath = BasicInfo.FILE_API + item.cThumbnailpath

      this.cFileDialog = true;
    },

    CloseDialog() {
      this.cFileDialog = false;
      this.NowSelFile = null
    },

    bSendSvrFile(NowSelFile){
      var d = new Date();
      var Year = d.getFullYear(); 
      
      var fileName = NowSelFile.name;
      var Extend = Util.getExtension(fileName).toUpperCase();
      var sFileTypeId = Util.sGetId(Util.sGetFileType(NowSelFile.type));
        
      let formData = new FormData();
      formData.append('uploadfile', NowSelFile);
      return new Promise((resolve) => (
        axios.post(BasicInfo.UIL_API + "UploadFile?PublicFile=Y&Year="+Year+"&FileNm="+fileName+"&Extend="+Extend+"&MimeType="+NowSelFile.type+"&Size="+NowSelFile.size+"&FileTypeId="+sFileTypeId,
                formData,
                {
                headers: {
                  'Content-Type' : 'multipart/form-data',
                }
              }
            )
            .then(res => {
              resolve(res);
            })
            .catch(err =>{
              resolve(null);
              EventBus.$emit("onShowMsg",true, "파일저장에 실패하였습니다. 관리자에게 문의 바랍니다." + err)
          })
      ));
    },

    async SetPenaltyInfo() {
      this.loading = true;

      if (this.NowSelFile != null) {
        var res = await this.bSendSvrFile(this.NowSelFile);
        if (res.data.ResultCd == "00") {
          this.editedItem.cFileId = res.data.FileId;
          this.editedItem.cFileNm = res.data.FileNm;
          this.editedItem.cThumbnailpath = res.data.ThumbnailFilePath;
        } else {
          EventBus.$emit("onShowMsg",true, "파일 저장에 실패하였습니다. 관리자에게 문의 바랍니다.");
          this.loading = false;
          return;
        }        
      }

      var posData = {
        PenaltyId : this.editedItem.cPenaltyId,
        SubMissionCustomId : this.CustomInfo.CustomId,
        CorpId : this.CustomInfo.CorpId,
        Manager : this.CustomInfo.Manager,
        FileId : this.editedItem.cFileId,
        State : this.editedItem.cState,
      }

      axios
        .post(BasicInfo.UIL_API + "SetPenaltyInfo", posData , {
            headers: {
             "Authorization": this.CustomInfo.Token
            }
          })
        .then(res => {
          this.loading = false;
          if (res.data.ResultCd == "44") { EventBus.$emit("onTokenExpired"); return; }
          if (res.data.ResultCd == "66") { EventBus.$emit("onChangeCorpInfo"); return; }
          if (res.data.ResultCd === "00") {
            this.cFileDialog = false;
            this.NowSelFile = null

            this.Records[this.iEditIndex].cSubMissionCustomId = this.CustomInfo.CustomId
            this.Records[this.iEditIndex].cFileId = this.editedItem.cFileId
            this.Records[this.iEditIndex].cFileNm = this.editedItem.cFileNm
            this.Records[this.iEditIndex].cThumbnailpath = this.editedItem.cThumbnailpath
            this.Records[this.iEditIndex].cState = "S"
            this.Records[this.iEditIndex].cSubMissionDate = res.data.Result[0].cSubMissionDate

            EventBus.$emit("onShowMsg",false, "사유서/공문 제출이 완료 되었습니다.");
          } else if (res.data.ResultCd === "02") {
            this.$store.dispatch('logout',"DelCustomId");
            EventBus.$emit("onShowMsgBox","삭제된 회원입니다", "로그인 화면으로 이동합니다.");
          } else if (res.data.ResultCd === "04") {
            EventBus.$emit("onShowMsgBox","삭제된 항목입니다.", res.data.Msg);
          } else if (res.data.ResultCd === "06" || res.data.ResultCd === "08") {
            EventBus.$emit("onShowMsgBox",res.data.Msg, "화면을 새로 고침하여 확인하여 주세요.");
          } else {
            EventBus.$emit("onShowMsg",true, res.data.Msg);
          }
        })
        .catch(err =>{ 
          EventBus.$emit("onShowMsg",true, err);
          this.loading = false;
        }) 
    },

    GetPenaltyInfo(){
      var posData = {
        CustomId : this.CustomInfo.CustomId,
        CorpId : this.CustomInfo.CorpId,
        Manager : this.CustomInfo.Manager,
        StartDate : this.sStartDate,
        EndDate : this.sEndDate,
      }
      axios
        .post(BasicInfo.UIL_API + "GetPenaltyInfo", posData , {
            headers: {
             "Authorization": this.CustomInfo.Token
            }
          })
        .then(res => {
          if (res.data.ResultCd == "44") { EventBus.$emit("onTokenExpired"); return; }
          if (res.data.ResultCd === "00") {
            if (res.data.Result.length == 0) {
              this.cNoMsg = ""
              setTimeout(() => {
                this.cNoMsg = "보안규정 위반내역 없습니다."
              }, 300);
            }

            let i = 0;
            for (i in res.data.Result) {
              res.data.Result[i].sNum = Number(i) + 1
            }

            this.Records = res.data.Result;
          } else {
            EventBus.$emit("onShowMsg",true, res.data.Msg);
          }
        })
        .catch(err =>{ 
          EventBus.$emit("onShowMsg",true, err);
        }) 
    },

  }
}
</script>